// DEV-4720: a required exposed role is "filled" once the loan carries an active (not un-assigned)
// assignment for it. The unfilled set drives both the inline Required indicator and, server-side,
// the submission/milestone Required-role gate — so the copy here names each unfilled role.
const getActiveAssignedRoleIds = (loanRoles = []) =>
  loanRoles
    .filter(loanRole => !loanRole.isUnassigned && !loanRole.isInitiallyUnassigned)
    .map(loanRole => loanRole.loanRoleId);

export const getUnfilledRequiredRoles = (requiredExposures = [], loanRoles = []) => {
  const assignedRoleIds = getActiveAssignedRoleIds(loanRoles);

  return requiredExposures.filter(exposure => !assignedRoleIds.includes(exposure.loanRoleId));
};

export const getUnfilledRequiredMessage = (unfilledRequiredRoles = []) => {
  if (!unfilledRequiredRoles.length) {
    return null;
  }

  const roleNames = unfilledRequiredRoles.map(role => role.name).join(', ');

  return `Assign a user to every required role before submitting this loan: ${roleNames}.`;
};

export const checkHasMissingAssigneeNames = (loanRoles = []) =>
  loanRoles.some(loanRole => !loanRole.userName);

// DEV-5503: loan-info omits userName on assignments the viewer's user directory can't resolve
// (e.g. a broker viewing the auto-placed Partner Loan Originator), while the loan-roles history
// endpoint returns the same assignment WITH the name — so the history rows are the fallback
// name source. History rows carry roleName (not loanRoleId); prefer the exact assignedDate match,
// then the newest named row for that role (rows arrive sorted date-desc).
export const backfillAssigneeNamesFromHistory = (loanRoles = [], history = []) =>
  loanRoles.map(loanRole => {
    if (loanRole.userName) {
      return loanRole;
    }

    const namedRoleEntries = history.filter(
      entry => entry.roleName === loanRole.roleName && entry.userName,
    );
    const exactDateEntry = namedRoleEntries.find(entry => entry.date === loanRole.assignedDate);
    const userName = (exactDateEntry ?? namedRoleEntries[0])?.userName;

    return userName ? { ...loanRole, userName } : loanRole;
  });
